export const ROUTES = {
  HOME: "/",
  DESARROLLO: "/desarrollo",
  INFRAESTRUCTURA: "/infraestructura",
  SERVICIOS_CLOUD: "/servicios-cloud",
  SERVICIOS_TI: "/servicios-ti",
  PROYECTOS: "/proyectos",
  SERVIDORES_DEDICADOS: "/servidores-dedicados",
  CONTACTO: "/contacto",
  QUIENES_SOMOS: "/quienes-somos",
  POLITICAS_PRIVACIDAD: "/politicas-privacidad",
  LOGIN_EXTERNO: "https://mantenimientos.tecnotics.co/?isInvited=true",
  VPS_COTIZAR: "/servidores-vps",
  NUBE_COTIZAR: "/servidores-nube",
  OFFICE365_COTIZAR: "/servicios-cloud/office365",
  ACRONIS_COTIZAR: "/servicios-ti/acronis",
  KASPERSKY: "/servicios-ti/kaspersky",
  
  // Rutas de proyectos individuales
  PROYECTO_HEMOGROUP: "/proyectos/hemogroup",
  PROYECTO_VLIPS: "/proyectos/vlips",
  PROYECTO_TERMINAL_SUR: "/proyectos/terminal-sur",
  PROYECTO_ADMIN_SOPORTE: "/proyectos/admin-soporte",
  PROYECTO_ADMIN_SOPORTE_CATALOGO: "/proyectos/admin-soporte/catalogo",
  PROYECTO_ORDENA_FACIL: "/proyectos/ordena-facil",
  PROYECTO_ORDENA_FACIL_CATALOGO: "/proyectos/ordena-facil/catalogo",
  PROYECTO_FACTURACION: "/proyectos/facturacion-electronica",
  PROYECTO_FACTURACION_CATALOGO: "/proyectos/facturacion-electronica/catalogo",
  PROYECTO_MI_TURNO: "/proyectos/mi-turno",
  PROYECTO_MI_TURNO_CATALOGO: "/proyectos/mi-turno/catalogo",
  PROYECTO_SERVICIOS: "/proyectos/servicios",
  PROYECTO_SERVICIOS_CATALOGO: "/proyectos/servicios/catalogo"
} as const;

export type AppRoutes = (typeof ROUTES)[keyof typeof ROUTES];
